import Input2 from '../input-2/Input2';
import styles from './input-search.module.less';
import { forwardRef } from 'react';

const InputSearch = ({ title = 'Søk', onClickSearchIcon, ...props }, ref) => (
    <Input2
        {...props}
        title={title}
        inputCreator={({ className, ...inputProps }) => (
            <>
                <i
                    className={[
                        'far fa-magnifying-glass',
                        onClickSearchIcon ? styles.searchIconClickable : styles.searchIcon,
                    ].join(' ')}
                    onClick={() => onClickSearchIcon?.()}
                />
                <input
                    {...inputProps}
                    className={[className, styles.searchInput, 'ffe-input-field'].join(' ')}
                    ref={ref}
                />
            </>
        )}
    />
);
export default forwardRef(InputSearch);
